import module from 'finanzas/module.js'
import template from './template.html'

module.config(($dialogProvider) => {
  $dialogProvider.dialog('finanzas.detallesFacturacion.detalle.nominas.nomina', {
    controller: 'FinanzasDetallesFacturacionDetalleNominasNomina',
    controllerAs: '$ctrl',
    template,
  })
})

function FinanzasDetallesFacturacionDetalleNominasNominaController ($dialogParams, dialog, NominasCatalogo, $scope) {
  var $ctrl = this

  $ctrl.options = {
    payroll: undefined,
    company: undefined,
  }

  $ctrl.loading = false

  $ctrl.catalogos = {
    nominas: undefined,
    Empresas: $dialogParams['Empresas'],
  }

  $ctrl.$cancel = function () {
    dialog.reject()
  }

  $ctrl.$select = function () {
    dialog.resolve({
      ID_Nomina: $ctrl.options.payroll.ID_Nomina,
      Tipo_Moneda: $ctrl.options.payroll.Tipo_Moneda,
      Subtotal: $ctrl.options.payroll.Suministro,
      Comision_Porcentaje: $ctrl.options.payroll.Comision_Porcentaje,
      Comision: $ctrl.options.payroll.Comision_Importe,
      IVA: $ctrl.options.payroll.IVA,
      Notas: $ctrl.options.payroll.Notas,
      Total: $ctrl.options.payroll.Total,
    })
  }

  $scope.$watch('$ctrl.options.company', function (ID_Empresa) {
    if (ID_Empresa) {
      $ctrl.loading = true
      NominasCatalogo.select([
        'ID_Nomina', 'Tipo_Moneda', 'Notas', 'Suministro', 'Comision_Porcentaje', 'Comision_Importe', 'IVA', 'Total',
      ], [ID_Empresa]).then(function (list) {
        $ctrl.catalogos.nominas = list
      }).finally(function () {
        $ctrl.loading = false
      })
    }
  })
}

module.controller('FinanzasDetallesFacturacionDetalleNominasNomina', FinanzasDetallesFacturacionDetalleNominasNominaController)



// WEBPACK FOOTER //
// ./src/finanzas/_/detallesFacturacion/detalle/nominas/nomina/controller.js